<div class="fits-needs-toggle-div d-flex">
  <div class="monthly-div d-inline-block"><span class="word-span col-grey font-outfit fs-16-lh-20 fw-normal"
                                                [class.checked]="isLeftSelected">{{ leftLabel }}</span></div>
  <label class="switch position-relative d-inline-block">
    <input type="checkbox" (click)="select()" [value]="!isLeftSelected" class="opacity-0 h-0 w-0">
    <span class="slider round position-absolute cursor-pointer top-0 end-0 start-0 bottom-0"></span>
  </label>
  <div class="annually-div d-inline-block"><span class="word-span col-grey font-outfit fs-16-lh-20 fw-normal"
                                                 [class.checked]="!isLeftSelected">{{ rightLabel }}</span></div>
</div>
